import {Injectable} from '@angular/core';
import {BaseApiEndpointService} from "../../../../../services/api/services/BaseApiEndpoint.service";
import {Backend, SingleResponse} from "@generated-backend-types";
import {Observable} from "rxjs";
import { HttpEvent } from "@angular/common/http";
import {ListItem} from "ng-multiselect-dropdown/multiselect.model";
import Attachment = Backend.App.Http.Resources.Dashboard.Attachment;
import AttachmentData = Backend.App.Data.Attachments.AttachmentData;

@Injectable({
  providedIn: 'root'
})
export class AttachmentsApiService extends BaseApiEndpointService<Attachment, Partial<AttachmentData>> {

  protected override endpoint = '/administrations/attachments'

  public setEndpoint(endpoint: string): void {
    this.endpoint = endpoint;
  }

  public resetToDefaultEndpoint(): void {
    this.endpoint = '/administrations/attachments';
  }


  public upload(data: AttachmentData): Observable<HttpEvent<SingleResponse<Attachment>>> {
    const formData = new FormData();
    formData.set('file', data.file);
    formData.set('name', data.name);
    formData.set('path', data.path);

    return this.http.post<SingleResponse<Attachment>>(this.endpoint, formData, {
      reportProgress: true,
      observe: 'events'
    })
  }

  modelToMultiSelectItem(m: Backend.App.Http.Resources.Dashboard.Attachment): ListItem & {
    model: Backend.App.Http.Resources.Dashboard.Attachment
  } {
    return {
      id: m.id,
      text: m.name,
      isDisabled: false,
      model: m,
    }
  }


}
